"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Trans: () => import_react_i18next.Trans,
  default: () => src_default,
  useTranslation: () => import_react_i18next.useTranslation
});
module.exports = __toCommonJS(src_exports);
var import_i18next = __toESM(require("i18next"));
var import_react_i18next = require("react-i18next");

// src/translations/locales/en/ai.json
var ai_default = {
  ai_art_feed: {
    heading: "Find and Use Stunning AI Art",
    description: "Browse the most stunning AI art on Kittl, ready to use for your next project.",
    description_element: "Browse the most stunning AI art on Kittl,<0 />ready to use for your next project.",
    clipboard_button_text: "Copy link to clipboard",
    kittl_ai_text: "Kittl AI"
  },
  ai_tool: {
    mobile_upload_image_text: "Upload image",
    upload_image_text: "Drag and drop or <0>{{uploadText}}</0>",
    supported_file_types_text: "Supported Files: JPEG, PNG"
  }
};

// src/translations/locales/en/collab.json
var collab_default = {
  share: {
    access: {
      can_view: "Can view",
      can_edit: "Can edit",
      user_remove_fail: "Could not remove access, please try again later",
      user_remove_success_design: "Access removed from project",
      user_remove_success_presentation: "Access removed from presentation",
      notification_accept: "Open project",
      notification_decline: "Dismiss"
    },
    remove: "Remove",
    invite: {
      too_frequent: "Invite sent recently, please try again later",
      generic_failure: "Could not resend invite, please try again later",
      resend: "Resend invitation",
      resend_success: "Email invite sent again"
    },
    live: {
      MAX_SESSIONS_PER_USER_PER_DOC_REACHED: "This project can\u2019t be loaded because it\u2019s open in too many tabs",
      MAX_SESSIONS_PER_DOC_REACHED: "Too many people are currently collaborating on this project. Please try again in a moment",
      SCHEMA_OUTDATED_ERROR: "We have just updated the app to enhance your experience. Please refresh the page."
    }
  },
  toast: {
    edit_text_font_missing: "Text can't be edited because the font is missing"
  },
  workspaces: {
    settings: {
      delete_workspace: {
        toast_success: "Team deleted",
        toast_failed: "Team delete failed",
        action: "Delete team",
        prompt: "By deleting this team, you and all members will immediately lose access to all projects. This action is permanent and cannot be undone."
      },
      admin: {
        set_name_label: "Team name"
      }
    }
  }
};

// src/translations/locales/en/comment.json
var comment_default = {
  toast: {
    marker_visible: "Comments always visible",
    marker_hidden: "Comments visible only in Comment mode",
    network_error: "Comments are unavailable in offline mode"
  },
  sort: {
    by_date: "Sort by date",
    by_unread: "Sort by unread"
  },
  filter: {
    trigger_tooltip: "Filter",
    show_resolved_comments: "Show resolved comments"
  }
};

// src/translations/locales/en/common.json
var common_default = {
  enable_cookies: "Please enable cookies to use this site.",
  account_needed: "You need an account to use the editor."
};

// src/translations/locales/en/focusMode.json
var focusMode_default = {
  "banner.content": "You are currently updating a Master Asset.",
  "back_button.label": "<-- Discard Changes",
  "submit_changes_button.label": "Submit Changes"
};

// src/translations/locales/en/publishModal.json
var publishModal_default = {
  decision_modal_message: "You can't publish a design that is using custom uploaded fonts.",
  decision_modal_title: "We are sorry",
  publish_modal_heading: "Publish Design to Community",
  design_is_ready: "Your design is being prepared for publishing...",
  created_by: "Created by",
  publish_premium_template: "Publish as Premium Template",
  earn_revenue_share: "Earn revenue share by offering your design as a Premium Template. Kittl reserves the right to determine whether your template remains free or becomes premium, and this status may change over time.",
  click_here: "Click here",
  size: "Size:",
  learn_more: "to learn more.",
  learn_more_and_view: "to learn more and view current challenges.",
  submit: "Submit to a Challenge",
  optional: "(optional)",
  design_challenge: "Want to take part in a design challenge?",
  agree: "I agree with the",
  publishing_design_guidelines: "Publishing Design Guidelines",
  challenge_rules: "Challenge Rules"
};

// src/translations/locales/en/subscriptionModal.json
var subscriptionModal_default = {
  "trial_explanation.heading": "How trial works",
  "trial_explanation.title_today": "Today: Get instant access",
  "trial_explanation.description_today_pro": "Start using Kittl Pro features.",
  "trial_explanation.description_today_expert": "Start using Brand Kits and other Kittl Expert features.",
  "trial_explanation.title_mid": "Day {{number}}: Trial reminder",
  "trial_explanation.description_mid": "We'll send you an email reminder, just to be safe.",
  "trial_explanation.title_end": "Day {{number}}: Trial ends",
  "trial_explanation.description_end": "Your subscription will start on {{date}}.",
  "testimonial.name_pro": "Denis Walker",
  "testimonial.text_pro": "Kittl is super easy to use and takes away the hassle of design, which helps me create amazing stuff quickly for my clients.",
  "testimonial.name_expert": "Alicia Kavalev",
  "testimonial.text_expert": "Brand Kits allow our team to speed up our process and keep our assets consistent across the whole org.",
  "free_trial.hold_note": "We will verify your payment method, but you will not be charged until after your free trial ends.",
  "pay_subscription_button.upgrade_now": "Upgrade Now",
  "pay_subscription_button.start_free_trial": "Start Free Trial",
  "pay_subscription_button.update_subscription": "Updating subscription...",
  "pay_subscription_button.error_message": "Failed to update subscription. Please, try again later."
};

// src/index.ts
var resources = {
  en: {
    collab: collab_default,
    common: common_default,
    comment: comment_default,
    subscriptionModal: subscriptionModal_default,
    focusMode: focusMode_default,
    ai: ai_default,
    publishModal: publishModal_default
  }
};
import_i18next.default.use(import_react_i18next.initReactI18next).init({
  resources,
  lng: "en",
  ns: [
    "collab",
    "common",
    "comment",
    "subscriptionModal",
    "ai",
    "publishModal"
  ],
  defaultNS: "common",
  keySeparator: ".",
  interpolation: {
    escapeValue: false
  }
});
var src_default = import_i18next.default;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Trans,
  useTranslation
});
